var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-layout",class:{isIphonex:_vm.isIphonex}},[_c('div',{staticClass:"weui-layout-bd"},[_vm._t("default")],2),_c('FitWxPhonex',{staticClass:"weui-layout-ft",on:{"resize":_vm.onResize}},[_vm._t("ft")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }